/**
 * URL-ul unui fișier de sub `uploads/`, servit de `GET /file/<cale>` — ACUM AUTENTIFICAT.
 *
 * Linkurile `<a href>`, `window.open` și viewer-ele (PDF / XLSX / miniaturi) nu pot pune header
 * `Authorization`, așa că tokenul merge în `?token=` (strategia JWT îl acceptă, la fel ca la
 * audio-ul ședințelor). Compromisul: tokenul ajunge în istoricul browserului și în logurile
 * serverului — de aceea rămâne doar pentru fișiere, nu pentru API.
 *
 * Singura excepție publică (fără token) e `logo.png`, referit din emailurile către clienți.
 */
const BACKEND_URI = process.env.VITE_BACKEND_URI;

export const fileUrl = (path: string | null | undefined): string => {
  const token = localStorage.getItem('token') || '';
  const clean = (path ?? '').replace(/^\/+/, '');
  return `${BACKEND_URI}/file/${clean}?token=${encodeURIComponent(token)}`;
};
